export default __webpack_public_path__ + "static/media/NotAllowed.36a56794.mp3";